import { render, staticRenderFns } from "./ApiEditor.vue?vue&type=template&id=b81b1fc0&scoped=true&"
import script from "./ApiEditor.vue?vue&type=script&lang=js&"
export * from "./ApiEditor.vue?vue&type=script&lang=js&"
import style0 from "./ApiEditor.vue?vue&type=style&index=0&id=b81b1fc0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b81b1fc0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VRadio } from 'vuetify/lib'
import { VRadioGroup } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VSwitch } from 'vuetify/lib'
import { VTab } from 'vuetify/lib'
import { VTabItem } from 'vuetify/lib'
import { VTabs } from 'vuetify/lib'
import { VTabsItems } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VIcon,
  VLayout,
  VRadio,
  VRadioGroup,
  VSelect,
  VSwitch,
  VTab,
  VTabItem,
  VTabs,
  VTabsItems,
  VTextField,
})
